/**
 * source: https://github.com/nagix/chartjs-plugin-colorschemes/tree/master
 * @license MIT
 *
 * The plugin is no longer needed because v4 of chart.js allows easy setting of dataset color schems
 * Only using the color sets
 */

import { colorBrewer } from "./colorschemes.brewer";
import { office } from "./colorschemes.office";
import { tableau } from "./colorschemes.tableau";

export const ColorSchemes = {
  other: {
    default: [
      "#36a2eb",
      "#ff6384",
      "#4bc0c0",
      "#ff9f40",
      "#9966ff",
      "#ffcd56",
      "#c9cbcf",
    ],
    colorful25a: [
      "#4E79A7",
      "#F28E2C",
      "#E15759",
      "#76B7B2",
      "#59A14F",
      "#EDC949",
      "#AF7AA1",
      "#FF9DA7",
      "#9C755F",
      "#BAB0AC",
      "#1F77B4",
      "#FF7F0E",
      "#2CA02C",
      "#D62728",
      "#9467BD",
      "#8C564B",
      "#E377C2",
      "#7F7F7F",
      "#BCBD22",
      "#17BECF",
      "#A1C4D4",
      "#E39E3B",
      "#F9E076",
      "#6D904F",
      "#B07AA1",
    ],
    colorful25b: [
      "#1B9A59",
      "#C43C32",
      "#8A6BBE",
      "#735041",
      "#EE82EE",
      "#B0B0B0",
      "#D4A017",
      "#1693A5",
      "#8FA3BF",
      "#E3B088",
      "#FFEC8B",
      "#65C18C",
      "#B68CB8",
      "#3B5A9D",
      "#F2B134",
      "#D94D4C",
      "#7DCFB6",
      "#6AB187",
      "#F1E189",
      "#AC80A0",
      "#FFB6C1",
      "#9A7B4F",
      "#CAC7C7",
      "#344E86",
      "#FC7E2A",
    ],
  },
  colorBrewer,
  office,
  tableau,
};
